import {Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'rox-dialog-prime',
  templateUrl: 'dialog-prime.component.html',
  styleUrls: ['dialog-prime.component.sass']
})
export class DialogPrimeComponent {
  @Input() data;
  @Input() show;
  @Input() style = {
    width: '744px'
  }
  @Input() disableSaveBtn: Boolean = false
  @Input() showEditBtn: Boolean = false;
  @Input() titleName;
  @Input() showSaveBtn: Boolean = true;
  @Input() nameApplyBtn = 'Save';
  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() edit = new EventEmitter();

  constructor( ) {}

  saveDialog() :void {
    this.save.emit();
  }

  closeDialog() : void {
    this.show = false
    this.close.emit();
  }

  onEdit() : void {
    this.edit.emit();
  }
}
